import { CountdownPart } from '../Components/CountdownPart'
import { useRhythmicRender } from '../Hooks/useRythmeicRenderer'
import { capitalizeFirstLetter } from '../Functions'
import { HStack, VStack } from '../Components/Stack'
import { Text } from '../Components'
import { useMediaQuery } from '@mui/material'
// import { useEffect, useState } from 'react'


export const S_IN_MIN = 60
export const H_IN_DAY = 24
export const D_IN_WEEK = 7
export const S_IN_HOUR = S_IN_MIN * S_IN_MIN
export const S_IN_DAY = H_IN_DAY * S_IN_HOUR
export const H_IN_WEEK = H_IN_DAY * D_IN_WEEK
export const MIN_IN_HOUR = 60
export const MIN_IN_DAY = H_IN_DAY * MIN_IN_HOUR

export const MS_IN_SEC = 1000
export const MS_IN_MIN = S_IN_MIN * MS_IN_SEC
export const MS_IN_HOUR = S_IN_MIN * MS_IN_MIN
export const MS_IN_DAY = H_IN_DAY * MS_IN_HOUR
export const MS_IN_WEEK = 7 * MS_IN_DAY
export const NS_IN_MS = 1000000

const countdownUnits = ['days', 'hours', 'minutes', 'seconds'] as const
const countdownUnitsHebrew = { days: 'ימים', hours: 'שעות', minutes: 'דקות', seconds: 'שניות' } as const
type CountdownUnit = (typeof countdownUnits)[number]
const msInUnit: Record<CountdownUnit, number> = {
  days: MS_IN_HOUR * 24,
  hours: MS_IN_HOUR,
  minutes: MS_IN_MIN,
  seconds: MS_IN_SEC,
}

interface Props {
  endsAt: number
  precision?: CountdownUnit
}

const formatDuration = (durationInMs: number, units: CountdownUnit[]) => {
  const duration = {} as Record<CountdownUnit, number>

  units.reduce((msLeft, unit, index) => {
    const msInCurrentUnit = msInUnit[unit]
    const isLast = index === units.length - 1
    const roundFunction = isLast ? Math.round : Math.floor
    const period = roundFunction(msLeft / msInCurrentUnit)
    duration[unit] = period

    return msLeft - period * msInCurrentUnit
  }, durationInMs)

  return duration
}

export const Countdown = ({ endsAt, precision = 'seconds' }: Props) => {
  // const [endsAtDefined, setEndsAtDefined] = useState(false);

  // useEffect(() => {
  //   if (endsAt) {
  //     setEndsAtDefined(true);
  //   }
  // }, [endsAt]);

  const isMobile = useMediaQuery('(max-width: 700px)')


  useRhythmicRender();

  const now = Date.now()

  // todo adapt to multilanguage - use countdownUnitsHebrew if language is hebrew
  const unitsToShow = countdownUnits.slice(
    0,
    countdownUnits.indexOf(precision) + 1,
  )

  // once endsAt is defined do not update the seconds to avoid flickering. this should be done by: 
  const duration = formatDuration(Math.max(endsAt - now, 0), unitsToShow)

  return (
    <HStack gap={isMobile ? 12 : 24}>
      {unitsToShow.map((unit) => {
        return (
          <VStack key={precision + unit} gap={6}>
            <CountdownPart value={duration[unit] || 0} />
            <Text style={{ margin: 0 }} size={14}>{capitalizeFirstLetter(countdownUnitsHebrew[unit])}</Text>
          </VStack>
        )
      })}
    </HStack>
  )
}
